import React from 'react';

interface Props {
    size?: number;
    className?: string;
    /** Цвет «клевера». Если не задан — наследует currentColor (напр. серый в футере). */
    color?: string;
}

// Логотип-«клевер» list.am. Приближённая SVG-версия фирменного знака.
// Если нужен точный официальный файл — положи PNG/SVG в assets и подмени.
const ListAmLogo: React.FC<Props> = ({ size = 18, className, color }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign: 'middle', flexShrink: 0, color }}
        aria-hidden="true"
    >
        <rect x="1.5" y="1.5" width="11" height="11" rx="4.5" fill="currentColor" />
        <rect x="15.5" y="1.5" width="11" height="11" rx="4.5" fill="currentColor" />
        <rect x="1.5" y="15.5" width="11" height="11" rx="4.5" fill="currentColor" />
        <rect x="15.5" y="15.5" width="11" height="11" rx="4.5" fill="currentColor" />
    </svg>
);

export default ListAmLogo;
